window.$ = window.jQuery = require('jquery');

require('bootstrap');
require('~/jquery.easing/jquery.easing');

// ========================== CSRF Token par défaut pour ajax

$.ajaxSetup({headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}});

// ========================== Navigation

$("a[data-scroll]").on("click",function(e) {
    e.preventDefault();
    var id = $(this).data('scroll');
    var pos = Math.round($('#'+id).position().top);
    if(id !== 'page') pos += 26;
    $("html, body").animate({ scrollTop:pos },700,"easeInOutQuart",function(){!1})
});

$("header .mobile-menu").on("click", function(e){
    e.preventDefault();
    $("header").toggleClass("open");
    $("header #menu-wrapper").toggleClass("active");
    $("header .mobile-menu i").toggleClass('fa-times').toggleClass('fa-bars');
});

$("header nav a").on('click', function () {
    $("header").removeClass("open");
    $("header #menu-wrapper").removeClass('active');
    $("header .mobile-menu i").toggleClass('fa-times').toggleClass('fa-bars');
});

// ========================== Back to top

$(window).on("scroll",function() {
    if ($(window).scrollTop() >= 80) {
        $("body").addClass("scroll");
        $("#backToTop").fadeIn();
    } else {
        $("body").removeClass("scroll");
        $("#backToTop").fadeOut();
    }
}).trigger('scroll');

$("#backToTop").on("click touchstart",function(e) {
    e.preventDefault();
    $("html, body").animate({ scrollTop:0 },700,"easeInOutQuart",function(){!1})
});

// ========================== Masquage du header

var prevScrollpos = window.pageYOffset;
$(window).on('scroll', function() {
    var currentScrollPos = this.pageYOffset;
    $('header').removeClass('down');
    if (prevScrollpos < currentScrollPos && currentScrollPos > 60) {
        $('header').addClass('down');
    }
    prevScrollpos = currentScrollPos;
})

// ========================== Fake links

$(document).on('click', '*[data-href]', function(e) {
    e.preventDefault;
    window.location=$(this).data("href")
});
